export function installZohoErrorFilter() {
  console.info('Installing Zoho error filter');
  if (window.__zohoErrorFilterInstalled) return;
  window.__zohoErrorFilterInstalled = true;

  const isZohoFile = (src = '') =>
    src.includes('static.zohocdn.com/helpcenter/asapweb') ||
    src.includes('zohocdn.com') ||
    src.includes('desk.zoho.com') ||
    src.includes('ZohoDeskEditor.js');

  // Captures runtime script errors
  window.addEventListener(
    'error',
    (event) => {
      const msg = event?.message || '';
      const src = event?.filename || '';

      // ignore Zoho ASAP errors
      if (isZohoFile(src)) {
        event.preventDefault();
        event.stopImmediatePropagation?.();
      }

      // also ignore the generic cross origin case if it somehow arrives without filename
      if (msg === 'Script error.' && (isZohoFile(src) || src === '')) {
        event.preventDefault();
        event.stopImmediatePropagation?.();
      }
    },
    true, // capture phase helps catch it earlier
  );

  // Captures unhandled promise rejections from Zoho scripts
  window.addEventListener(
    'unhandledrejection',
    (event) => {
      const reason = event?.reason;
      const msg = reason?.message ? reason.message : String(reason || '');

      if (
        msg.includes('ZohoDeskEditor') ||
        msg.includes('asapweb') ||
        msg.includes('zohocdn.com') ||
        msg.toLowerCase().includes('zoho')
      ) {
        event.preventDefault();
        event.stopImmediatePropagation?.();
      }
    },
    true,
  );
}
